import mixin from '@lottery.2.0/library/mixin.js'
export default mixin